/**
 * Webfonts used by map lettering and atlas artwork. Canvas text (Pixi Text, atlas glyphs) does not
 * wait for webfonts, so the renderer awaits them before drawing any lettering.
 */
import '@fontsource/eb-garamond/latin-400.css';
import '@fontsource/eb-garamond/latin-400-italic.css';
import '@fontsource/eb-garamond/latin-500.css';
import '@fontsource/eb-garamond/latin-500-italic.css';
import '@fontsource/eb-garamond/latin-600.css';
import '@fontsource/eb-garamond/latin-700.css';
import '@fontsource/ibm-plex-mono/latin-600.css';
import '@fontsource/ibm-plex-sans-condensed/latin-700.css';
import '@fontsource/special-elite/latin-400.css';

export const SERIF = '"EB Garamond", Garamond, "Times New Roman", serif';
export const STENCIL = '"Special Elite", "Courier New", monospace';
export const MONO = '"IBM Plex Mono", monospace';

const FACES = [
  '400 16px "EB Garamond"',
  'italic 400 16px "EB Garamond"',
  '500 16px "EB Garamond"',
  'italic 500 16px "EB Garamond"',
  '600 16px "EB Garamond"',
  '700 16px "EB Garamond"',
  '600 16px "IBM Plex Mono"',
  '700 16px "IBM Plex Sans Condensed"',
  '400 16px "Special Elite"',
];

let ready: Promise<void> | null = null;

/** Resolves once every face is loaded (or after 2.5 s — fallbacks beat a blank map). */
export function loadFonts(): Promise<void> {
  if (!ready) {
    const all = Promise.all(FACES.map((f) => document.fonts.load(f).catch(() => []))).then(() => undefined);
    ready = Promise.race([all, new Promise<void>((r) => setTimeout(r, 2500))]);
  }
  return ready;
}
